/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Cta_ExampleInputs */

const da_forside_cta_example = /** @type {(inputs: Forside_Cta_ExampleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se eksempelprøven`)
};

/** @type {(inputs: Forside_Cta_ExampleInputs) => LocalizedString} */
const en_forside_cta_example = da_forside_cta_example;

/**

* @param {Forside_Cta_ExampleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_cta_example = /** @type {((inputs?: Forside_Cta_ExampleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Cta_ExampleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_cta_example(inputs)
	return /** @type {LocalizedString} */ ("Se eksempelprøven")
});